import { render, staticRenderFns } from "./CustomSharingOptions.vue?vue&type=template&id=76892bb4&"
import script from "./CustomSharingOptions.vue?vue&type=script&lang=js&"
export * from "./CustomSharingOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports